/* Touch ME — interacciones del tema (sin dependencias) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ----- Menú móvil ----- */
  var drawer = $('[data-drawer]');
  var openBtn = $('[data-drawer-open]');
  if (drawer && openBtn) {
    var closeDrawer = function () {
      drawer.hidden = true;
      document.body.classList.remove('is-locked');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    };
    openBtn.addEventListener('click', function () {
      drawer.hidden = false;
      document.body.classList.add('is-locked');
      openBtn.setAttribute('aria-expanded', 'true');
      var first = $('.drawer__close', drawer);
      if (first) first.focus();
    });
    $$('[data-drawer-close]', drawer).forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }

  /* ----- Selector de cantidad (+ / −) ----- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var input = $('input', btn.parentNode);
    if (!input) return;
    var min = input.min === '' ? 0 : parseInt(input.min, 10);
    var value = parseInt(input.value, 10) || 0;
    value += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    if (value < min) value = min;
    if (String(value) === input.value) return;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Envío automático: carrito y orden de colección ----- */
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (el.matches('[data-cart-qty], [data-autosubmit]') && el.form) el.form.submit();
  });

  /* ----- Formularios de cuenta ----- */
  $$('select[data-default]').forEach(function (select) {
    var value = select.getAttribute('data-default');
    if (!value) return;
    $$('option', select).forEach(function (option) {
      if (option.value === value || option.textContent === value) select.value = option.value;
    });
  });
  $$('form[data-confirm]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!window.confirm(form.getAttribute('data-confirm'))) event.preventDefault();
    });
  });

  /* ----- Página de producto: variantes ----- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (error) { return; }

    var groups = $$('[data-option]', root);
    if (!groups.length) return;

    var select = $('[data-variant-select]', root);
    var addBtn = $('[data-add]', root);
    var addLabel = $('[data-add-label]', root);
    var priceNow = $('[data-price-now]', root);
    var priceWas = $('[data-price-was]', root);
    var gallery = $('[data-gallery]', root);

    var selected = function () {
      return groups.map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    };

    var markSoldOut = function (current) {
      groups.forEach(function (group, index) {
        $$('input', group).forEach(function (input) {
          var canBuy = variants.some(function (variant) {
            if (!variant.available || variant.options[index] !== input.value) return false;
            return variant.options.every(function (option, i) {
              return i === index || option === current[i];
            });
          });
          input.classList.toggle('is-soldout', !canBuy);
        });
      });
    };

    var setButton = function (state) {
      if (!addBtn) return;
      addBtn.disabled = state !== 'add';
      if (addLabel) addLabel.textContent = addBtn.getAttribute('data-label-' + state) || '';
    };

    var update = function (fromUser) {
      var current = selected();
      markSoldOut(current);
      var variant = variants.filter(function (v) {
        return v.options.every(function (option, i) { return option === current[i]; });
      })[0];

      if (!variant) { setButton('none'); return; }

      if (select) select.value = String(variant.id);
      if (priceNow) priceNow.innerHTML = variant.price;
      if (priceWas) {
        priceWas.hidden = !variant.compare;
        if (variant.compare) priceWas.innerHTML = variant.compare;
      }
      setButton(variant.available ? 'add' : 'soldout');

      if (!fromUser) return;
      if (variant.media && gallery) {
        var media = $('[data-media-id="' + variant.media + '"]', gallery);
        if (media && media !== gallery.firstElementChild) gallery.insertBefore(media, gallery.firstElementChild);
        if (gallery.scrollTo) gallery.scrollTo({ left: 0, behavior: 'smooth' });
      }
      if (window.history && history.replaceState) {
        var base = root.getAttribute('data-url') || window.location.pathname;
        history.replaceState({}, '', base + '?variant=' + variant.id);
      }
    };

    groups.forEach(function (group) {
      group.addEventListener('change', function () { update(true); });
    });
    update(false);
  });

  /* ----- Productos relacionados ----- */
  $$('[data-recommendations]').forEach(function (section) {
    if (section.children.length || !window.fetch) return;
    fetch(section.getAttribute('data-url'))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html;
        var fresh = $('[data-recommendations]', holder);
        if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* sin recomendaciones: la sección queda vacía */ });
  });
})();
